import { ReactNode, HTMLAttributes } from 'react'

interface ToolbarProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
}

export const Toolbar = ({ children, ...rest }: ToolbarProps) => (
  <div
    id="level-play-toolbar"
    className="mx-auto w-[90%] flex items-center justify-between relative"
    {...rest}
  >
    {children}
  </div>
)
